export enum TradeActionType {
  CONFIRM,
  COMMENT,
  CANCEL,
}

export namespace TradeActionType {
  let elements = [TradeActionType.CONFIRM, TradeActionType.COMMENT, TradeActionType.CANCEL];
  let alias = "com.bcdfx.model.TradeActionType";

  export function RemoteClass() {
    return alias;
  }

  export function getAllElements() {
    return elements;
  }
}
